import { render, staticRenderFns } from "./WidgetPassageChildren.vue?vue&type=template&id=93a48bec&"
import script from "./WidgetPassageChildren.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageChildren.vue"
export default component.exports